/**
 * Client-stored "last seen" timestamp powering SinceList (doc 04 §9, doc 01
 * A1.1). Purely local — never sent to the server.
 */
const KEY = 'cwos.admin.lastSeen';
const DAY_MS = 86_400_000;

export function readLastSeen(): Date {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw) {
      const d = new Date(raw);
      if (!Number.isNaN(d.getTime())) return d;
    }
  } catch {
    // storage unavailable — fall through to default
  }
  return new Date(Date.now() - DAY_MS);
}

export function writeLastSeen(when: Date): void {
  try {
    window.localStorage.setItem(KEY, when.toISOString());
  } catch {
    // storage unavailable — best-effort only
  }
}
